var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "timeline" },
    [
      _vm._l(_vm.list, function (t, i) {
        return _c(
          "div",
          {
            key: (t.alertId || "alert") + "-" + i,
            staticClass: "timeline-item",
            class: _vm.kindOf(t.alertType),
          },
          [
            _c("div", { staticClass: "ti-head" }, [
              _c(
                "span",
                { staticClass: "tag", class: _vm.clsOf(t.alertType) },
                [
                  _vm._v(" " + _vm._s(_vm.typeZh(t.alertType))),
                  _c("span", { staticClass: "pt" }, [
                    _vm._v(" / " + _vm._s(_vm.typePt(t.alertType))),
                  ]),
                ]
              ),
              _c("span", { staticClass: "ti-title" }, [
                _vm._v(_vm._s(t.uf) + " · " + _vm._s(t.title)),
              ]),
            ]),
            _c("div", { staticClass: "ti-time" }, [
              _vm._v(_vm._s(_vm.fmtTs(t.ts))),
            ]),
            _c("div", { staticClass: "ti-body" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.sendZh(t.sendStatus)) +
                  " · 接收群：" +
                  _vm._s(t.recipientName || "—") +
                  " "
              ),
              _c("span", { staticClass: "pt pt-block" }, [
                _vm._v(
                  _vm._s(_vm.sendPt(t.sendStatus)) +
                    " · Grupo: " +
                    _vm._s(t.recipientName || "—")
                ),
              ]),
            ]),
          ]
        )
      }),
      !_vm.list.length
        ? _c("div", { staticClass: "empty" }, [
            _vm._v("暂无告警记录"),
            _c("span", { staticClass: "pt" }, [_vm._v(" / Nenhum alerta")]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }